import React, { useState, useCallback } from 'react';
import {
  func, string, bool, object, number,
} from 'prop-types';

import MuiModal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Button, Alert } from '@avon/component-library';
import { isMobile } from '../../utils/getDeviceType';
import closeSvg from '../../styles/assets/close.svg';

const Modal = ({
  open,
  fnInCloseModal,
  closeModal,
  heading,
  body,
  submitData,
  saveLabel,
  cancelLabel,
  successModal,
  isSubmitting,
  icon,
  iconLabel,
  iconWidth,
  iconHeight,
  color,
  crossClose,
  language,
}) => {
  const theme = useTheme();
  const isNotMobile = useMediaQuery(theme.breakpoints.up('sm'));
  const [secondModal, setSecondModal] = useState(false);
  const [lang] = useState(language);

  const renderSecondModal = useCallback(async () => {
    if (!isSubmitting) {
      const submitted = await submitData();
      if (submitted) {
        setSecondModal(true);
      } else {
        closeModal();
      }
    }
  }, [isSubmitting, submitData]);

  const closeAndReset = useCallback(() => {
    closeModal();
    setSecondModal(false);
  });

  return secondModal && !successModal ? null : (
    <MuiModal
      data-testid="submit-modal"
      id="submit-modal"
      open={open}
    >
      <Box
        minWidth={320}
        maxWidth={isNotMobile ? 568 : 355}
        position="relative"
        top={window.screen.height > 640 ? '15%' : '2%'}
        transform="translate(-50%)"
        margin="auto"
      >
        <Paper>
          {secondModal ? (
            <Box p={4}>
              <Alert
                id="prp-alert"
                {...successModal}
                iconType="check"
                handleClick={closeAndReset}
              />
            </Box>
          ) : (
            <Box p={9} data-testid="error-modal" id="error-modal">
              {crossClose && (
                <Box
                  textAlign={lang && lang === 'ar' ? 'left' : 'right'}
                  onClick={fnInCloseModal
                    ? () => { fnInCloseModal(); closeModal(); }
                    : closeModal}
                >
                  <img
                    alt="close-modal"
                    src={closeSvg}
                  />
                </Box>
              )}
              {icon && (
                <Box textAlign="center" mb={6}>
                  <Box
                    height={iconWidth || 64}
                    width={iconHeight || 64}
                    borderRadius={iconWidth / 2 || 32}
                    border={`2px solid ${color && color.borderColor}` || '#293132'}
                    color={(color && color.fontColor) || '#293132'}
                    textAlign="center"
                    lineHeight={iconHeight ? `${iconHeight}px` : '64px'}
                    display="inline-block"
                  >
                    <Box component="span" fontSize={iconHeight ? `${iconHeight / 2}px` : '64px'}>
                      {iconLabel || '?'}
                    </Box>
                  </Box>
                </Box>
              )}
              <Box mb={5} textAlign="center">
                <Typography variant="h2">{heading}</Typography>
              </Box>
              <Box mt={5} textAlign="center">
                {(body && <Typography priority="h4">{body}</Typography>)}
              </Box>
              <Box style={{
                display: 'flex',
                flexDirection: isMobile() ? 'column' : 'row',
                justifyContent: isMobile() ? 'unset' : 'center',
                // eslint-disable-next-line no-nested-ternary
                direction: isMobile() ? 'unset' : (lang === 'ar' ? 'ltr' : 'rtl'),
              }}
              >
                <Box
                  minWidth="230px"
                  mt={5}
                  // eslint-disable-next-line
                  ml={isMobile() ? 'unset' : (lang === 'ar' ? 'unset' : '5px')} mr={isMobile() ? 'unset' : (lang === 'ar' ? '5px' : 'unset')}>
                  <Button
                    priority="secondary"
                    name="submit-modal-save"
                    id="submit-modal-save"
                    onClick={renderSecondModal}
                    loading={isSubmitting}
                  >
                    {saveLabel}
                  </Button>
                </Box>
                {
                  cancelLabel && (
                    <Box
                      minWidth="230px"
                      mt={5}
                      // eslint-disable-next-line
                      ml={isMobile() ? 'unset' : (lang === 'ar' ? '5px' : 'unset')} mr={isMobile() ? 'unset' : (lang === 'ar' ? 'unset' : '5px')}>
                      <Button
                        priority="tertiary"
                        name="submit-modal-close"
                        id="submit-modal-close"
                        onClick={
                          fnInCloseModal
                            ? () => { fnInCloseModal(); closeModal(); }
                            : closeModal
                        }
                      >
                        {cancelLabel}
                      </Button>
                    </Box>
                  )
                }
              </Box>
            </Box>
          )}
        </Paper>
      </Box>
    </MuiModal>
  );
};

Modal.propTypes = {
  heading: string,
  body: string,
  fnInCloseModal: func,
  closeModal: func,
  open: bool.isRequired,
  submitData: func.isRequired,
  saveLabel: string.isRequired,
  cancelLabel: string,
  successModal: object,
  isSubmitting: bool,
  icon: bool,
  iconLabel: string,
  iconWidth: number,
  iconHeight: number,
  color: object,
  crossClose: bool,
  language: string,
};

export default Modal;
